<template lang="pug">
  .content
    BBreadcrumb(
      v-if="crumbs"
      :items="crumbs"
    )
    Transition
      RouterView
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('crumbs', ['crumbs'])
  }
}
</script>

<style lang="sass">
.breadcrumb
  font-size: 12px
  background-color: transparent
  padding: 0
</style>
